var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    viewBox: "0 -3 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "volume-muted"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch Beta."), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311 -573)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m336.44 585 4.173-4.173c0.45-0.45 0.492-1.139 0.094-1.538-0.399-0.398-1.088-0.356-1.538 0.094l-4.173 4.173-4.173-4.173c-0.45-0.45-1.139-0.492-1.538-0.094-0.398 0.399-0.356 1.088 0.094 1.538l4.173 4.173-4.173 4.173c-0.45 0.45-0.492 1.139-0.094 1.538 0.399 0.398 1.088 0.356 1.538-0.094l4.173-4.173 4.173 4.173c0.45 0.45 1.139 0.492 1.538 0.094 0.398-0.399 0.356-1.088-0.094-1.538l-4.173-4.173zm-11.444-12-7 4.667v14.666l7 4.667c1.104 0 2-0.896 2-2v-20c0-1.104-0.896-2-2-2zm-14 8v8c0 1.104 0.896 2 2 2h3v-12h-3c-1.104 0-2 0.896-2 2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.fcf85dbdc681e7848986a370a109e4fa.svg";
export { ForwardRef as ReactComponent };